<template>
  <div class="centro">
    <h1>Cadastro para acompanhamento de publicações</h1>

    <Loading v-if="carregando" />
    <ErroResultados
      texto="Houve um erro ao carregar os dados"
      v-if="!carregando && erroCarregando"
    />

    <template v-if="!carregando && !erroCarregando">
      <form @submit="cadastrar">
        <!-- aparece so quando cadastra um email com sucesso -->
        <div class="cad-sucesso" v-if="exibirMsgSucesso">
          <p><span>&#10004;</span> Email cadastrado com sucesso!</p>
        </div>

        <!-- aparece so quando dar erro ao salvar email (ex: salvar email repetido) -->
        <div class="cad-erro" v-if="erroSalvando">
          <p><span> &#10008;</span> {{erroSalvando}}</p>
        </div>
        <div class="form">          
          <p>
           Cadastro para receber e-mails informando sobre as publicações de Emendas à 
           Constituição Estadual, Leis Ordinárias, Leis Complementares e Decretos Numerados, disponibilizados 
           no site Legisla Goiás, após publicação no <a target="_blank" href='https://diariooficial.abc.go.gov.br/'>Diário Oficial do Estado de Goiás.</a>
          </p>        
          <div class="linha1">
            <div class="item">
              <label>Nome:<span>*</span></label>
              <input type="text" v-model="nome" required />
            </div>
            <div class="item">
              <label>Frequência:<span>*</span></label>
              <select v-model="frequencia" required>
                <option :value="0">Diariamente</option>
                <option :value="1">Semanalmente</option>
                <option :value="2">Quinzenalmente</option>
              </select>
            </div>
          </div>
          <div class="linha2">
            <div class="item">
              <label>Email:<span>*</span></label>
              <input type="text" v-model="email" required />
            </div>
            <div class="item">
              <label>Confirmar Email:<span>*</span></label>
              <input type="text" v-model="confirmarEmail" required />
            </div>
          </div>
          <div class="linha2">
            <div class="item">
              <label>País:<span>*</span></label>
              <select v-model="paisId" @change="estadoId = null" required>
                <option v-for="pais in paises" :key="pais.id" :value="pais.id">{{pais.nome}}</option>
              </select>
            </div>
            <div class="item" v-if="paisSelecionado && paisSelecionado.estados.length > 0">
              <label>Estado:<span>*</span></label>
              <select v-model="estadoId">
                <option
                  v-for="estado in paisSelecionado.estados"
                  :key="estado.id"
                  :value="estado.id"
                >{{estado.nome}}</option>
              </select>
            </div>
          </div>

          <div class="check-ciente">
            <label class="checkbox bounce" for="ciente">
              <input type="checkbox" v-model="ciente" name="ciente" id="ciente"/>
              <svg viewBox="0 0 21 21">
                  <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
              </svg>
      
              <label for='ciente'>Estou ciente de que este serviço é meramente informativo, não tendo, portanto, cunho oficial.</label>
            </label>
          </div>
          <div class="botao">
            <button type="submit" :disabled="salvando">{{salvando ? 'Salvando' : 'Cadastrar'}}</button>
          </div>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
import EmailAcompanhamentoPublicacaoApi from "../services/EmailAcompanhamentoPublicacaoApi";
import PaisesApi from "../services/PaisesApi";
import Loading from "../components/Loading";
import ErroResultados from "../components/ErroResultados";

import metaDados from "../helpers/metaDados";

const get = require("lodash.get");

export default {
  name: "CadastroAcompanhamentoPublicacoes",
  metaInfo() {
    return {
      title: "Cadastro para acompanhamento de publicações",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content: "Cadastro para acompanhamento de publicações"
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "Cadastro para acompanhamento de publicações"
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            "Cadastro para acompanhamento de publicações - Casa Civil do Estado de Goiás"
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article"
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Cadastro para acompanhamento de publicações - Casa Civil do Estado de Goiás"
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content:
            "Cadastro para acompanhamento de publicações - Casa Civil do Estado de Goiás"
        },
        ...metaDados(this.$route)
      ]
    };
  },
  data() {
    return {
      nome: null,
      email: null,
      confirmarEmail: null,
      frequencia: 0,
      paisId: 1,
      estadoId: null,
      ciente: null,
      erroCarregando: false,
      carregando: true,
      erroSalvando: null,
      salvando: false,
      paises: [],
      exibirMsgSucesso: false
    };
  },
  components: {
    Loading,
    ErroResultados
  },
  created() {
    this.paisesApi = new PaisesApi();
    this.emailAcompanhamentoPublicacaoApi = new EmailAcompanhamentoPublicacaoApi();
    this.carregar();
  },
  methods: {
    async carregar() {
      try {
        this.carregando = true;
        this.erroCarregando = false;
        this.paises = await this.paisesApi.getPaises();
        this.carregando = false;
      } catch (err) {
        console.log(err);
        this.erroCarregando = true;
        this.carregando = false;
      }
    },
    async cadastrar(e) {
      e.preventDefault();

      if (this.ciente) {
        if (this.email && this.email !== this.confirmarEmail) {
          alert("Email e confirmação de email devem ser iguais");
          return;
        }
        try {
          this.exibirMsgSucesso = false;
          this.salvando = true;
          this.erroSalvando = null;

          await this.emailAcompanhamentoPublicacaoApi.cadastrarEmail({
            nome: this.nome,
            email: this.email,
            frequencia: this.frequencia,
            paisId: this.paisId,
            estadoId: this.estadoId
          });
          this.exibirMsgSucesso = true;
          this.salvando = false;

          this.nome = null;
          this.email = null;
          this.confirmarEmail = null;
          this.frequencia = null;
          this.paisId = null;
          this.estadoId = null;
          this.ciente = false;
        } catch (err) {
          console.log(err);
          const mensagem = get(err, "response.data.mensagem");
          this.erroSalvando =
            mensagem ||
            "Houve um erro ao cadastrar o email. Por favor tente novamente";
          this.salvando = false;
        }
      } else {
        alert("É necessário marcar o campo de ciência");
      }
    }
  },
  computed: {
    paisSelecionado: function() {
      if (this.paises && this.paisId) {
        return this.paises.find(pais => pais.id == this.paisId);
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-family: "Poppins-Bold";
  color: #2c3f2b;
  padding-left: 0.5rem;
  border-left: #ffa900 solid 0.15rem;
  margin: 2.5rem 0rem 1.5rem 1rem;
  font-size: 1.5rem;
  line-height: 2rem;
}
.cad-sucesso{
  margin-left: 1rem;
  background-color: rgb(4, 104, 4);
  padding: .5rem 0rem;
  margin: 1rem auto;
  text-align: center;
  span{
    color: white;
    font-size: 1.2rem;
  }
  p{
    color: white;
    font-size: .9rem;
    margin: 0rem;
  }
}
.cad-erro{
  margin-left: 1rem;
  background-color: rgb(192, 0, 0);
  padding: .5rem 0rem;
  margin: 1rem auto;
  text-align: center;
  p{
    color: white;
    font-size: .9rem;
    margin: 0rem;
    span{
      font-size: 1.2rem;
    }
  }
}
.form{
  padding: 0.5rem 1rem 5rem;
  min-height: calc(100vh - 17rem);
  p{
    margin: 0rem 0rem 1rem;
  }
  .item{
    display: grid;
    margin-bottom: .5rem;
    label{
      font-size: .9rem;
    }
    input{
      width: calc(100% - 1rem);
      height: 2rem;
      border-radius: 0.2rem;
      border: #2c3f2b solid .05rem;
      padding-left: 0.5rem;
      font-family: "Poppins";
      font-size: 1rem;
      letter-spacing: 0.03rem;
    }
    select{
      width: calc(100% - .25rem);
      height: 2rem;
      border-radius: 0.2rem;
      border: #2c3f2b solid .05rem;
      padding-left: 0.5rem;
      font-family: "Poppins";
      font-size: 1rem;
      letter-spacing: 0.03rem;
      background-color: white;
    }
    span{
      color: red;
    }
  }
}
.check-ciente{
  margin-top: 2rem;
  span{
    font-size: .9rem;
    text-indent: 3rem;
  }
  .checkbox {
      --background: #fff;
      --border: #D1D6EE;
      --border-hover: #BBC1E1;
      --border-active: #2c3f2b;
      --tick: #fff;
      position: relative;
      input,
      svg {
          width: 21px;
          height: 21px;
          display: inline-block;
      }
      input {
          -webkit-appearance: none;
          -moz-appearance: none;
          position: relative;
          outline: none;
          background: var(--background);
          border: none;
          margin: 0 1rem -.3rem 0rem;
          padding: 0;
          cursor: pointer;
          border-radius: 4px;
          transition: box-shadow .3s;
          box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--border));
          &:hover {
              --s: 2px;
              --b: var(--border-hover);
          }
          &:checked {
              --b: var(--border-active);
          }
      }
      svg {
          pointer-events: none;
          fill: none;
          stroke-width: 2px;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke: var(--stroke, var(--border-active));
          position: absolute;
          top: 0;
          left: 0;
          width: 21px;
          height: 21px;
          transform: scale(var(--scale, 1)) translateZ(0);
      }
      &.path {
          input {
              &:checked {
                  --s: 2px;
                  transition-delay: .4s;
                  & + svg {
                      --a: 16.1 86.12;
                      --o: 102.22;
                  }
              }
          }
          svg {
              stroke-dasharray: var(--a, 86.12);
              stroke-dashoffset: var(--o, 86.12);
              transition: stroke-dasharray .6s, stroke-dashoffset .6s;
          }
      }
      &.bounce {
          --stroke: var(--tick);
          input {
              &:checked {
                  --s: 11px;
                  & + svg {
                      animation: bounce .4s linear forwards .2s;
                  }
              }
          }
          svg {
              --scale: 0;
          }
      }
  }

  @keyframes bounce {
      50% {
          transform: scale(1.2);
      }
      75% {
          transform: scale(.9);
      }
      100% {
          transform: scale(1);
      }
  }

  html {
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
  }
}
.botao{
  margin-top: 2rem;
  text-align: center;
  button{
      background-color: #2c3f2b;
      color: #ffa900;
      border: solid 0.15rem #2c3f2b;
      font-size: .9rem;
      letter-spacing: .05rem;
      padding: .5rem 2rem;
      cursor: pointer;
      border-radius: .5rem;
  }
}
@media screen and (min-width: 64rem){
  .form{
    min-height: calc(100vh - 40rem);
  }
  .linha1{
    display: grid;
    grid-template-columns: 69% 30%;
    gap: 1%;
  }
  .linha2{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1%;
  }
  .check-ciente{
    margin-top: 1rem;
  }
}
.alto-contraste{
  p{
    color: white;
  }
  .form{
    label{
      color: white;
    }
  }.botao{
  button{
      background-color: #ffa900;
      color: #2c3f2b;
      border: solid 0.15rem #ffa900;
      font-size: .9rem;
      letter-spacing: .05rem;
      padding: .5rem 2rem;
      cursor: pointer;
      border-radius: .5rem;
  }
}
}
</style>